/* eslint-disable max-len */
import create from '@platform/adapter/pin/api/create'
import init from '@platform/adapter/pin/api/init'

/**
 * PinEventListener
 *
 * @memberOf Gaia.Adapter.Pin.API
 * @callback PinEventListener
 * @param {Object} event                    the event object
 * @param {Object} event.detail             the event's detail object containing custom data
 * @returns {Promise<ParsedPin>}
 */

/**
 * @memberOf Gaia.Adapter.Pin
 * @namespace API
 * @typedef Adapter.Pin.API
 *
 * @property {function} init          inits the pin adapter
 * @property {function} create        creates a pin from a QR code
 * @param {Gaia.Web.Application} app  Platform Web Application
 * @returns {{}}
 */
const api = app => Object.create({}, {
  init: {
    value: init(app),
    iterable: true,
    enumerable: true,
  },
  create: {
    value: create(app),
    iterable: true,
    enumerable: true,
  },
})

export default api
